import React from 'react';
import { Stack } from '@mui/material';
import MaterialTypography from '../../../../components/MaterialTypography';
import MaterialInput from '../../../../components/MaterialInput';

const Introduction = ({ formData, handleChange }) => {
    return (
        <Stack spacing={2}>
            <MaterialTypography variant="caption" fontWeight="bold">Introduction</MaterialTypography>
            <MaterialInput
                name="introduction"
                value={formData.introduction}
                onChange={handleChange}
                placeholder="Enter Introduction"
                multiline
                rows={5}
                fullWidth
            />
        </Stack>
    );
};

export default Introduction;
